import ImageConverterTemplate from "../components/ImageConverterTemplate";

export default function ConvertWebpToPng() {
  return (
    <ImageConverterTemplate
      sourceFormat="WebP"
      targetFormat="PNG"
      acceptTypes=".webp,image/webp"
      slug="convert-webp-to-png"
      gradientColors="from-green-500 to-blue-500"
      accentColor="blue"
    />
  );
}
